<template>
  <div>
    <div v-if="data && data.creationReferenceNumber">
      <TitleField
        :fieldName="'isCreationReferenceNumber'"
        :fieldGroup="'ruzdiDetails'"
      />
      <WrapperField
        v-for="(fieldValue, fieldName) in data"
        :key="fieldValue + fieldName + Math.random()"
        :data="
          createDataField({
            fieldName,
            fieldValue,
            fieldGroup: 'ruzdiDetails',
          })
        "
      ></WrapperField>
    </div>

    <div v-if="pledgorOrganization">
      <div class="form-base__label text-color-base">
        {{ PLEDGOR_TITLE }}
      </div>
      <div class="form-base__label text-color-base">
        российское юридическое лицо
      </div>
      <div class="row-box">
        <WrapperField
          v-for="(fieldValue, fieldName) in pledgorOrganization"
          :key="fieldValue + fieldName + Math.random()"
          :data="
            createDataField({
              fieldName,
              fieldValue,
              fieldGroup: 'pledgorOrganization',
            })
          "
        ></WrapperField>
      </div>
    </div>

    <div v-if="pledgorBusinessmen">
      <div class="form-base__label text-color-base">
        {{ PLEDGOR_TITLE }}
      </div>
      <div class="form-base__label text-color-base">
        индивидуальный предприниматель
      </div>
      <div class="row-box">
        <WrapperField
          v-for="(fieldValue, fieldName) in pledgorBusinessmen"
          :key="fieldValue + fieldName + Math.random()"
          :data="
            createDataField({
              fieldName,
              fieldValue,
              fieldGroup: 'pledgorPerson',
            })
          "
        ></WrapperField>
      </div>
    </div>

    <div v-if="pledgorPerson">
      <div class="form-base__label text-color-base">
        {{ PLEDGOR_TITLE }}
      </div>
      <div class="form-base__label text-color-base">физическое лицо</div>
      <div class="row-box">
        <WrapperField
          v-for="(fieldValue, fieldName) in pledgorPerson"
          :key="fieldValue + fieldName + Math.random()"
          :data="
            createDataField({
              fieldName,
              fieldValue,
              fieldGroup: 'pledgorPerson',
            })
          "
        />
      </div>
    </div>

    <div v-if="pledgorForeignOrganization">
      <div class="form-base__label text-color-base">
        {{ PLEDGOR_TITLE }}
      </div>
      <div class="form-base__label text-color-base">
        иностранное юридическое лицо или международная организация, имеющая
        права юридического лица
      </div>
      <div class="row-box">
        <WrapperField
          v-for="(fieldValue, fieldName) in pledgorForeignOrganization"
          :key="fieldValue + fieldName + Math.random()"
          :data="
            createDataField({
              fieldName,
              fieldValue,
              fieldGroup: FieldGroup.PLEDGOR_FOREIGN_ORGANIZATION,
            })
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';

export default {
  name: 'Step3',
  components: {
    WrapperField,
    TitleField,
  },
  props: ['data', 'subjects'],
  data: () => ({
    PLEDGOR_TITLE:
      'Получение информации обо всех уведомлениях о залоге движимого имущества в отношении определенного залогодателя',
    FieldGroup,
    createDataField,
  }),
  computed: {
    pledgorOrganization() {
      return this.subjects.pledgor?.organization;
    },

    pledgorBusinessmen() {
      if (this.subjects.pledgor?.person) {
        const person = this.subjects.pledgor.person;

        if (person.businessmenInfo) {
          return {
            ...person,
            ogrn: person.businessmenInfo.ogrn,
          };
        }
      }
      return null;
    },

    pledgorPerson() {
      if (this.subjects.pledgor?.person) {
        const person = this.subjects.pledgor.person;

        if (!person.businessmenInfo) return person;
      }
      return null;
    },

    pledgorForeignOrganization() {
      return this.subjects.pledgor?.foreignOrganization;
    },
  },
  methods: {},
};
</script>
